// extracted by mini-css-extract-plugin
export default {"updates-required-modal__content":"updates-required-modal_updates-required-modal__content__ANroM"};